import {
  THEME_CHANGE_EVENT,
  installThemeRuntime,
  isThemePreference,
  readThemePreference,
  setThemePreference,
} from "./theme";

const SELECTOR_TAG = "elevenx-appearance-selector";

function mountSelector(targetWindow: Window, host: Element): () => void {
  const labelText = host.getAttribute("label") || "Appearance";
  const label = targetWindow.document.createElement("label");
  label.className = "elevenx-appearance-picker";
  const caption = targetWindow.document.createElement("span");
  caption.textContent = labelText;
  const select = targetWindow.document.createElement("select");
  select.setAttribute("aria-label", labelText);

  for (const [value, text] of [
    ["system", "System"],
    ["light", "Light"],
    ["dark", "Dark"],
  ] as const) {
    const option = targetWindow.document.createElement("option");
    option.value = value;
    option.textContent = text;
    select.append(option);
  }

  const sync = () => {
    select.value = targetWindow.document.documentElement.dataset.themePreference
      || readThemePreference(targetWindow);
  };
  const handleChange = () => {
    if (isThemePreference(select.value)) {
      setThemePreference(targetWindow, select.value);
    }
  };

  select.addEventListener("change", handleChange);
  targetWindow.addEventListener(THEME_CHANGE_EVENT, sync);
  label.append(caption, select);
  host.replaceChildren(label);
  sync();

  return () => {
    select.removeEventListener("change", handleChange);
    targetWindow.removeEventListener(THEME_CHANGE_EVENT, sync);
  };
}

export function initializeStaticProductShell(targetWindow: Window = window): () => void {
  const cleanupRuntime = installThemeRuntime(targetWindow);
  const cleanupSelectors = Array.from(
    targetWindow.document.querySelectorAll(SELECTOR_TAG),
    (host) => mountSelector(targetWindow, host),
  );
  return () => {
    for (const cleanup of cleanupSelectors) cleanup();
    cleanupRuntime();
  };
}

if (typeof window !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeStaticProductShell(window), {
      once: true,
    });
  } else {
    initializeStaticProductShell(window);
  }
}
